import React, { memo, useEffect, useLayoutEffect, useState } from "react";
import NavigationPanel from "./navigation-panel/NavigationPanel";
import AuthPanel from "./auth-panel/AuthPanel";
import "./Navbar.module.css";
import BurgerButton from "./BurgerButton";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import MIcon from "../../common/m-icon/MIcon";
import useDeviceType from "../../../hooks/useDeviceType";
import LangSwitcher from "../../common/LangSwitcher/LangSwitcher";
import { handleLanguageChange } from "../../../utils/translation";
import { useTranslation } from "react-i18next";
import BviWidget from "../../common/BviWidget/BviWidget";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const role = useSelector((state) => state.user.activeRole);
  const isAuth = useSelector((state) => state.auth.isAuth);
  const [bgColor, setBgColor] = useState("bg-white");
  const { i18n } = useTranslation();
  const currentLang = i18n.language.split("-")[0];

  useEffect(() => {
    const handleResize = (event) => {
      if (event.target.innerWidth > 1440) {
        setIsOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  useLayoutEffect(() => {
    switch (role) {
      case "school_admin":
        setBgColor("bg-school_admin");
        break;
      case "teacher":
        setBgColor("bg-teacher");
        break;
      case "student":
        setBgColor("bg-student");
        break;
      case "private_user":
        setBgColor("bg-private_user");
        break;
      case "superadmin":
        setBgColor("bg-superadmin");
        break;
      default:
        setBgColor("bg-white");
    }
  }, [role]);

  const toggleNavbar = async () => {
    setIsOpen(!isOpen);
  };
  const { isMobile } = useDeviceType();

  const options =
    role !== "superadmin"
      ? [
          {
            name: "KZ",
            value: "kz",
          },
          {
            name: "RU",
            value: "ru",
          },
          {
            name: "EN",
            value: "en",
          },
        ]
      : [
          {
            name: "KZ",
            value: "kz",
          },
          {
            name: "RU",
            value: "ru",
          },
        ];

  useEffect(() => {
    if (role === "superadmin" && currentLang === "en") {
      handleLanguageChange("ru");
    }
  }, [currentLang, role]);

  return (
    <nav
      className={`flex justify-between items-center flex-wrap px-6 max-w-[1248px] mx-auto w-full ${
        isOpen ? "fixed bg-white z-[70]" : bgColor
      }`}
    >
      {(!isOpen || !isMobile) && (
        <Link to="/">
          <div className="h-[56px] mr-2 flex items-center">
            <MIcon
              type={"logo"}
              className={`${
                isAuth ? "text-white" : "text-main-color"
              } cursor-pointer `}
            />
          </div>
        </Link>
      )}
      {isOpen ? (
        <>
          <div className="hidden desktop:flex flex-row">
            <NavigationPanel role={role} />
          </div>

          <div className="flex items-center justify-end desktop:justify-end">
            {/*<LangSwitcher*/}
            {/*  classNameWrapper={isAuth ? "mr-4 text-white" : "mr-4 text-main-color"}*/}
            {/*  classNameDropDown={isAuth ? `bg-${role}` : "bg-white border border-main-color"}*/}
            {/*  currentLang={i18n.language.toUpperCase()}*/}
            {/*  setCurrentLang={handleLanguageChange}*/}
            {/*  options={options}*/}
            {/*/>*/}
            <div className="flex mr-2 desktop:mr-0 ">
              <AuthPanel
                isAuth={isAuth}
                role={role}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
              />
            </div>
            <BurgerButton
              toggleNavbar={toggleNavbar}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          </div>
        </>
      ) : (
        <>
          <div className="hidden desktop:flex flex-row">
            <NavigationPanel isAuth={isAuth} role={role} />
          </div>

          <div className="flex items-center justify-end desktop:justify-between">
            <BviWidget />
            <LangSwitcher
              classNameWrapper={
                isAuth ? "mr-4 text-white" : "mr-4 text-main-color"
              }
              classNameDropDown={
                isAuth ? `bg-${role}` : "bg-white border border-main-color"
              }
              currentLang={currentLang.toUpperCase()}
              setCurrentLang={handleLanguageChange}
              options={options}
            />
            <div className="hidden tablet:flex mr-2 desktop:mr-0 items-center">
              <AuthPanel
                isAuth={isAuth}
                role={role}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
              />
            </div>
            <BurgerButton
              toggleNavbar={toggleNavbar}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          </div>
        </>
      )}

      {isOpen && (
        <div className="flex flex-col basis-full h-screen border-t border-t-[#00000033]">
          <NavigationPanel
            toggle={toggleNavbar}
            isOpen={isOpen}
            role={role}
            isAuth={isAuth}
          />
        </div>
      )}
    </nav>
  );
}

export default memo(Navbar);
